import React, { useState, useEffect } from 'react';
import { getAccessToken } from '../../utils/auth';
import { LoginAuth } from '../../components/login/LoginAuth';
import DataTable from 'react-data-table-component';
import {
	Form,
	Button,
	Input,
} from 'reactstrap';
import {
	initialCompetenciaData,
	initialArrayCompetenciaData,
} from '../../api/Competencia/competenciaModel';

import {
    getCompetenciaApi, 
    createCompetenciaApi, 
    editCompetenciaApi
} from '../../api/Competencia/competencia';
import { InputCheckbox } from '../../components/Inputs/InputCheckbox';
import Notificacion from '../../components/snackbar/Notificacion';
import Tooltip from '@mui/material/Tooltip';
import { 
	Container,
	Box, 
	FormControl,
	TextField,
	IconButton
} from '@mui/material';
import Grid from '@mui/material/Grid';
import CancelIcon from '@mui/icons-material/Cancel';
import AddIcon from '@mui/icons-material/Add';
import '../../scss/abmEstilos.scss';
import Loading from '../../components/loading/Loading';
import SaveIcon from '@mui/icons-material/Save';

export default function Competencia() {
	const [isCreate, setIsCreate] = useState(true);
	const [isAnulado, setIsAnulado] = useState(true);
	const [isDisable, setIsDisable] = useState('');

	const [competenciaData, setCompetenciaData] = useState(initialCompetenciaData);

	const [arrayCompetenciaData, setArrayCompetenciaData] = useState(
		initialArrayCompetenciaData
	);
    
	const handleChangeCompetencia = event => {
		let texto = event.target.value;
		setIsDisable(texto);
		setCompetenciaData({
			...competenciaData,
			[event.target.name]: event.target.value,
		});
	};

	const handleEditCompetencia = event => {
		let id = event.target.dataset.id;
		let competencia = arrayCompetenciaData.filter(el => el.id == id);
		setIsDisable(competencia)
		if (competencia.length) {
			setCompetenciaData(competencia[0]);
			setIsCreate(false);

			if (competencia[0].anulado == 'N') {
				setIsAnulado(true);
			} else {
				setIsAnulado(false);
			}
		}
	};

	const handleSubmitCompetencia = event => {
		event.preventDefault();
		isCreate ? createCompetencia() : editCompetencia();
	};

	useEffect(() => {
		getArrayCompetencia();
	}, []);

	const columns = [
		{
			name: 'Competencias',
			selector: row => row.descripcion ? ( row.descripcion) : (''),
			cell: row =>
			row.descripcion ? (
				<div className= "dataTableText"> {row.descripcion} </div>
			) : (
				''
			),
			sortable: true,
			maxWidth: 200,
			minWidth: 140,
			width: 200,
			wrap: true,
			
		},
		{
			name: 'Estado',
			selector: row => row.anulado,
			cell: obj => {
				return (
					<div className="botonesTabla">
						{obj.anulado == 'N' ? (
							<div className="abmCampoVisible">
								<span className="material-symbols-rounded abmIcoVisi">
									visibility
								</span>
								Habilitado
							</div>
						) : (
							<div className="abmCampoDeshabilitar">
								<span className="material-symbols-rounded  abmIcoVisiOff">
									visibility_off
								</span>
								Deshabilitado
							</div>
						)}
					</div>
				);
			},
			sortable: true,
			maxWidth: 200,
			minWidth: 140,
			width: 200,
			wrap: true,
		},
		{
			cell: obj => {
				return (
					<div className="botonesTabla">
						<Tooltip title="Editar" placement="top" arrow>
							<IconButton
								data-id={obj.id ? obj.id : ''}
								className="material-symbols-rounded icoAbmEditar"
								onClick={handleEditCompetencia}
							>
								mode_edit
							</IconButton>
						</Tooltip>
					</div>
				);
			},
			right: true,
			ignoreRowClick: true,
			allowOverflow: true,
		},
	];

	const handleChangeAnulado = event => {
		let anulado = event.target.checked;
		setIsAnulado(anulado);
	};

	const handleClickCancelar = () => {
		setIsDisable('');
		clear();
	};

	const clear = () => {
        setIsDisable('');
		setIsCreate(true);
		setIsAnulado(true);
		setCompetenciaData(initialCompetenciaData);
	};

	const [OpenNoti, setOpenNoti] = React.useState(false);

	const notiConfigIni = {
		titulo: '',
		mensaje: '',
		estilo: 'notiSuccessFilled',
		tiempo: 4000,
		vertical: 'bottom',
		horizontal: 'center',
	};

	const [notiConfig,setNotiConfig] = useState(notiConfigIni);

	const _fieldObligatorio = () => {
		return <b style={{ color: 'red' }}>*</b>;
	};

	const emptyColumn = [
		{
			name: 'Competencias',
			cell: obj => {
				return <span>Sin competencias creadas.</span>;
			},
			left: true,
			ignoreRowClick: true,
			allowOverflow: true,
		},
	];

	const [dataTest, setDataTest] = useState([
		{
			descripcion: 'Sin competencias creadas.',
		},
	]);

	const [openLoad, setOpenLoad] = React.useState(false);

	const handleCloseLoad = () => {
		setOpenLoad(false);
	};

	const handleOpenLoad = () => {
		setOpenLoad(true);
	};

	if (getAccessToken()) {
		return (
			<Container className="contenedor">
				<div className="textoContenido">
					<h1 className="tituloContenido">Competencias</h1>
					<p className="parrafoContenido">
						Creá y configurá las competencias que formarán parte del contenido.
					</p>
				</div>

				<div className="textoContenido">
					<h2 className="subtituloContenido">Crear competencia</h2>

					<Box sx={{ flexGrow: 1 }}>
						<Grid container spacing={2}>
							<Grid item xs={8}>
								<FormControl className="descripAbm">
									<TextField
										id="descripcion"
										name="descripcion"
										label={
											<span style={{ fontFamily: 'Roboto' }}>
												Nombre de la competencia {_fieldObligatorio()}
											</span>
										}
										variant="outlined"
										inputProps={{ maxLength: 255 }}
										type="text"
										onChange={handleChangeCompetencia}
										value={competenciaData.descripcion || ''}
									/>
								</FormControl>
							</Grid>
							<Grid className='' item xs={4}>
								<div className="seccionInput">
									<InputCheckbox
										isAnulado={isAnulado}
										handleChangeAnulado={handleChangeAnulado}
										isDisable={!isDisable}
									></InputCheckbox>
								</div>
								<div className="btnContentAbm">
									<Button
										className="btnCrearAbm"
										disabled={!isDisable}
										onClick={handleSubmitCompetencia}
									>
										{isCreate ?
										<AddIcon  className='btnIcoAbm'/>
										:
										<SaveIcon className='btnIcoAbm'/>
										}
										{isCreate ? 'Crear' : 'Guardar'}
									</Button>
									<Button
										className="btnAbmCancel"
										onClick={handleClickCancelar}
										disabled={isCreate ? !isDisable : false}
									>
										<CancelIcon  className='btnIcoAbm'/>
										Cancelar
									</Button>
								</div>
							</Grid>
						</Grid>
					</Box>
				</div>

				<h2 className="subtituloContenido listado">Listado de competencias</h2>

				<DataTable
					columns={columns}
					className="dataTableContainer"
					data={arrayCompetenciaData ? arrayCompetenciaData : ''}
					direction="auto"
					fixedHeaderScrollHeight="300px"
					responsive
					subHeaderAlign="right"
					subHeaderWrap
					noDataComponent={
						<DataTable
							columns={emptyColumn}
							className="dataTableContainer"
							data={dataTest ? dataTest : ''}
							direction="auto"
							fixedHeaderScrollHeight="300px"
							responsive
							subHeaderAlign="right"
							subHeaderWrap
						/>
					}
					paginationPerPage={5}
					pagination
					paginationComponentOptions={{
						rowsPerPageText: 'Registros por página:',
						rangeSeparatorText: 'de',
					}}
					paginationRowsPerPageOptions={[5, 10, 15, 20, 50]}
				/>

				<Notificacion open={OpenNoti} setState={setOpenNoti} config={notiConfig} />
				<Loading
					bg="bgLoadingWhite"
					open={openLoad}
				/>
			</Container>
		);
	}

	async function getArrayCompetencia() {
		try {
			handleOpenLoad();
			let competencias = await getCompetenciaApi();
			setArrayCompetenciaData(competencias);
			handleCloseLoad();
		} catch (error) {
			console.log('🚀 ~ file: Example.js ~ line 55 ~ getUser ~ error', error);
		}
	}

	async function createCompetencia() {
		try {
			delete competenciaData.id;
			let descripcion = competenciaData.descripcion.trim();
			let anulado = isAnulado ? 'N' : 'S';

			let competencia = await createCompetenciaApi({ descripcion, anulado });
			setArrayCompetenciaData([...arrayCompetenciaData, competencia]);
			clear();
			notiConfig.estilo = 'notiSuccessFilled';
			notiConfig.mensaje = "Datos creados con éxito";
			setOpenNoti(true);
		} catch (error) {
			console.log('🚀 ~ file: Material.js:186 ~ createMaterial ~ error', error);

			let msj = await error.json();

			if (error.status == 422) {
				notiConfig.estilo = 'notiDangerFilled';
				notiConfig.mensaje = msj.violations[0].message;
				setOpenNoti(true);
			}
		}
	}

	async function editCompetencia() {
		try {
			console.log('🚀 ~ file: Proyecto.js:237 ~ editMaterial ~ editMaterial');
			let id = competenciaData.id;
			competenciaData.anulado = isAnulado ? 'N' : 'S';
			competenciaData.descripcion = competenciaData.descripcion.trim();
			await editCompetenciaApi(id, competenciaData);
			clear();
			setIsCreate(true);
			setCompetenciaData(initialCompetenciaData);
			getArrayCompetencia();
			notiConfig.estilo = 'notiSuccessFilled';
			notiConfig.mensaje = "Datos modificados con éxito";
			setOpenNoti(true);
		} catch (error) {
			console.log('🚀 ~ file: Material.js:187 ~ editMaterial ~ error', error);
			
			let msj = await error.json();

			if (error.status == 422) {
				notiConfig.estilo = 'notiDangerFilled';
				notiConfig.mensaje = msj.violations[0].message;
				setOpenNoti(true);
			}
		}
	}

	return (
		<>
			<LoginAuth></LoginAuth>
		</>
	);
}
